import {SanityBlockEmbed} from '~/types/sanityTypes';
import InnerHTML from 'dangerously-set-html-content';

export function BlockEmbed({blockContent}: {blockContent: SanityBlockEmbed}) {
  // https://www.npmjs.com/package/dangerously-set-html-content
  return (
    <>
      <div className="block-embed">
        <div className="container">
          <InnerHTML html={blockContent.script} />
        </div>
      </div>
    </>
  );
}
